import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { RMDClientFavouriteCarriersModel } from 'src/Models/RMDClientFavouriteCarriersModel';
import { RMDProviderFilterModel } from 'src/Models/RMDProviderFilterModel';
import { AppConfig } from 'src/Services/app.config';
import { CheckAuth } from '../../../../Services/utility.service';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { FrontRmdupdatesService } from 'src/Services/Frontrmdupdates.service';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { FrontRMDUpdatesModel } from 'src/Models/FrontRMDUpdatesModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-rmdcarriers',
  templateUrl: './rmdcarriers.component.html',
  styleUrls: ['./rmdcarriers.component.css']
})
export class RMDCarriersComponent implements OnInit {
  filter = new RMDProviderFilterModel();
  isShowprogressSpinner = false;
  blockedDocument = false;
  baseUrl: string;
  userID: number;
  queryParams: string = '';
  alldata: string = 'all';
  unreaddata: string = 'unread';
  isAscending: boolean = false
  upDownBussinessNameCSS: string = '';
  upDownGateway_providerCSS: string = '';
  upDownFrnCSS: string = '';
  upDownPrevious_dba_namesCSS: string = '';
  upDownOther_dba_namesCSS: string = '';
  upDownForeign_voice_providerCSS: string = '';
  upDownImplementationCSS: string = '';
  upDownSys_updated_onCSS: string = '';
  carrier: FrontRMDUpdatesModel;
  rmdUpdatesModel: FrontRMDUpdatesModel[];
  rmdFullUpdatesModel: FrontRMDUpdatesModel[];
  tokenKey: string = '';
  isloading: boolean;
  appModel: any;
  lastModifiedDetails = '';
  carrierForm: FormGroup;
  totalRecordCount: number = -1;
  carrierId: number;
  isFavorite: boolean;
  upDownIntermediate_provider: string = '';
  upDownipr_imported: string = '';

  stirShakenText: string = '';
  stirShakenType: string = '';
  rangeOfupdatesDates: any;

  rmdUnread: number = 0;
  rmdUnreadflag: boolean = true;


  constructor(private readonly htmlToPdf: HtmlToPdf, 
    private readonly rmdupdatesService: FrontRmdupdatesService, 
    private readonly toastr: ToastrService,
    private readonly titleService: Title, 
    private readonly checkAuth: CheckAuth,
    @Inject('BASE_URL') baseUrl: string,
    @Inject(Window) private readonly win: Window,
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService
  ) {
    this.baseUrl = baseUrl;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = +sessionStorage.getItem('UserId');
    //this.tokenKey = this.sessionStorageService.getTokenValue();
    this.appModel = AppConfig.settings.ConnectionStrings;

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
    this.titleService.setTitle('Providers | JSi360');
  }

  /** Wait for token if empty and then call init methods */
  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.movetotop();
    this.filter.orderBy = 'Sys_updated_on DESC';
    this.filter.userId = this.userID;
    this.filter.isFavorite = false;
    this.filter.pageNumber = 1;
    this.filter.pageSize = 10;
    this.upDownSys_updated_onCSS = 'active';
    this.isAscending = true;
    this.GetCarriers();
    this.GetRMDNotification();
    this.titleService.setTitle('Providers | JSi360');
  }

  ngOnInit() {
    // this.movetotop();
    // this.filter.orderBy = 'Sys_updated_on DESC';
    // this.filter.userId = this.userID;
    // this.filter.isFavorite = false;
    // this.filter.pageNumber = 1;
    // this.filter.pageSize = 50;
    // this.upDownSys_updated_onCSS = 'active';
    // this.isAscending = true;
    // this.tokenKey ="V2lyZWxlc3NHdWlkZSNBZG1pbiM2Mzg5NTUwOTI1NjgxODg0MjY=";
    // this.GetCarriers();
    // this.GetRMDNotification();
  }

  GetCarriers() {
    this.isloading = true;
    this.rmdUpdatesModel = [];
    this.rmdFullUpdatesModel = [];
    this.rmdupdatesService.GetFrontCarrierFilter(this.tokenKey, this.filter).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          
          this.rmdUpdatesModel = data['updates'];
          ApplicationActivityStore('View', 'RMD - Providers ', this.appActivity, ToolEnum.RMD, ActionActivity['Robocall Mitigation Database'], '/rmd/Providers');

          if (this.rmdUpdatesModel != null) {
            if (this.rmdUpdatesModel.length > 0) {
              this.totalRecordCount = this.rmdUpdatesModel[0].totalRecordCount;
              this.lastModifiedDetails = 'Last updated on ' + this.rmdUpdatesModel[0].lastModifiedDate;
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );

  }

  GetFullCarriers() {
    this.blockDocument();
    const filternew = Object.assign({}, this.filter);
    filternew.pageSize = 0;
    this.rmdupdatesService.GetFrontCarrierFilter(this.tokenKey, filternew).subscribe(
      data => {
        if (data != null) {
          this.rmdFullUpdatesModel = data['updates'];
          setTimeout(() => {
            let mainURL = this.baseUrl;
            let url = '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/AdminLTE.min.css"> <br> ';
            url += ' <link rel="stylesheet" href="' + mainURL + '/assets/css/bootstrap.min.css" asp-append-version="true" /> <br> ';
            url += ' <link id="adminstyle" rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"> <br> ';
            var html = url + document.getElementById('divPrint').innerHTML;
            this.htmlToPdf.CreatePDF(this.tokenKey, html, '0',ToolEnum.RMD).
              subscribe(data => {
                if (data['status'] == 'Success') {
                  this.downloadFile('Providers', data['url']);
                }
              },
                error => {
                  this.unblockDocument();
                }
              );
          }, 10000);
        }
      },
      error => {
        console.log(error);
      }
    );

  }

  updatesCarrierFilterClear() {
    this.filter.providerSearch = '';
    this.GetCarriers();
  }

  inputFilters($event, type) {
    if ($event.target.value != "" && $event.target.value != null)
      if (type == 1)
        this.filter.providerSearch = $event.target.value;
      else
        this.filter.keywordFilter = $event.target.value;
    else
      if (type == 1)
        this.filter.providerSearch = '';
      else
        this.filter.keywordFilter = '';
    this.filter.pageNumber = 1
    this.GetCarriers();
  }

  isUpdatesDatesFilter(value: any) {
    this.filter.pageNumber = 1;
    if (value != null) {
      if (value.length == 2) {
        this.filter.pageNumber = 1;
        const d = new Date(value[0]);
        const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

        const e = new Date(value[1]);
        const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');

        this.filter.fromDate = a;
        this.filter.todate = f;
        this.GetCarriers();
      }
    }
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  updatesDateFilterClear() {
    this.rangeOfupdatesDates = [];
    this.filter.fromDate = '';
    this.filter.todate = '';
    this.GetCarriers();
  }

  GetFavourite(IsFavourite: boolean) {
    this.filter.pageNumber = 1;
    this.filter.isFavorite = IsFavourite;
    this.GetCarriers();
  }


  cleanCssClass() {
    this.upDownBussinessNameCSS = '';
    this.upDownGateway_providerCSS= '';
    this.upDownFrnCSS= '';
    this.upDownPrevious_dba_namesCSS = '';
    this.upDownOther_dba_namesCSS = '';
    this.upDownForeign_voice_providerCSS = '';
    this.upDownImplementationCSS = '';
    this.upDownSys_updated_onCSS = '';
    this.upDownIntermediate_provider = '';
    this.upDownipr_imported = '';
  }

  sort(sortBy: any) {
    this.cleanCssClass();
    this.isAscending = !this.isAscending;
    this.filter.orderBy = this.isAscending ? sortBy : sortBy + ' DESC';

    switch (sortBy) {
      case "Business_name": this.upDownBussinessNameCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Gateway_provider": this.upDownGateway_providerCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Frn": this.upDownFrnCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Previous_dba_names": this.upDownPrevious_dba_namesCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Other_dba_names": this.upDownOther_dba_namesCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Foreign_voice_provider": this.upDownForeign_voice_providerCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Implementation": this.upDownImplementationCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Sys_updated_on": this.upDownSys_updated_onCSS = this.isAscending ? 'active' : 'active-up'; break;
      case "Intermediate_provider": this.upDownIntermediate_provider = this.isAscending ? 'active' : 'active-up'; break;
      case "ipr_imported": this.upDownipr_imported = this.isAscending ? 'active' : 'active-up'; break;
      default: break;
    }
    this.filter.pageNumber = 1;
    this.GetCarriers();
  }

  GetRMDUpdateById(carrierId) {
    this.carrier = undefined;
    this.blockDocument();
    this.rmdupdatesService.GetRMDUpdatesFindByCarrierID(this.tokenKey, carrierId).subscribe(
      data => {
        this.unblockDocument();
        if (data != null) {
          this.carrier = data['updates'];
        ApplicationActivityStore('View', 'RMD - Providers', this.appActivity, ToolEnum.RMD, ActionActivity['Robocall Mitigation Database'], '/RMD/Providers/details', null);
        }
      },
      error => {
        this.unblockDocument();
        console.log(error);
      }
    );

  }
  pageChanged($event: any) {
    this.filter.pageNumber = $event.page;
    this.GetCarriers();
  }

  AddToFavourite(id: number, isFavorite: boolean) {
    this.carrierId = id;
    this.isFavorite = isFavorite;
    if (!isFavorite) {
      var elem = document.getElementById("lnkFavouriteValidation");
      elem.click();
    }
    else {
      this.SaveFavoriteProvider();
    }
  }

  SaveFavoriteProvider() {
    const favouriteCarriersModel = new RMDClientFavouriteCarriersModel();
    favouriteCarriersModel.clientId = this.userID;
    favouriteCarriersModel.isFavourite = this.isFavorite;
    favouriteCarriersModel.carrierId = this.carrierId;
    this.rmdupdatesService.RMDClientCarrierFavouriteAddRemove(this.tokenKey, favouriteCarriersModel)
      .subscribe(data => {
        if (data["status"] == "Success") {
          this.rmdUpdatesModel.filter(x => x.carrierId == this.carrierId).forEach(element => {
            element.isFavorite = this.isFavorite;
          });
          if (this.isFavorite) {
            this.showMessage('Selected provider added successfully to favorite list.', 'Favorite', 'success');
          }
          else {

            this.showMessage('Selected provider removed successfully from favorite list.', 'Favorite', 'success');
          }
          document.getElementById("btnClose").click();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }

      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }

  pdfDocument() {
    this.GetFullCarriers();
  }

  public downloadFile(filename, url) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        ApplicationActivityStore('Download', 'RMD Providers File download ' + filename, this.appActivity, ToolEnum.RMD, ActionActivity['Robocall Mitigation Database'], '/rmd/providers/Details');
        sessionStorage.setItem('fileloading', 'false');
        this.unblockDocument();
      }
    );
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }
  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  setColor(textValue) {
    if (textValue != null) {
      if (textValue.toString().indexOf('Complete STIR') > -1) {
        return 'greenText';
      }
      else if (textValue.toString().indexOf('Partial STIR/SHAKEN') > -1) {
        return 'yellowText';
      }
      else if (textValue.toString().indexOf('No STIR/SHAKEN') > -1) {
        return 'redText';
      }
    }
  }

  downloadDocument(sys_id) {
    if (sys_id != null) {
      this.win.open('https://fccprod.servicenowservices.com/api/x_g_fmc_rmd/rmd/attachment?sys=' + sys_id);
    }
  }

  setstirShakenModelPopupText(type) {
    if (type == 'Complete') {
      this.stirShakenText = 'Complete STIR/SHAKEN Implementation. The filer certifies that all voice traffic that originates on its network is authenticated with STIR/SHAKEN, consistent with 47 CFR § 64.6301(a).';
      this.stirShakenType = 'Complete';
    }
    else if (type == 'Partial') {
      this.stirShakenText = 'Partial STIR/SHAKEN Implementation – Performing Robocall Mitigation. The filer certifies that it commits to respond to all traceback requests from the Commission, law enforcement, and the industry traceback consortium, and to cooperate with such entities in investigating and stopping any illegal robocallers that use its service to originate calls, and that some of the voice traffic that originates on its network is authenticated with STIR/SHAKEN, and the remainder of the voice traffic that originates on its network is subject to a robocall mitigation program. The filer also certifies that the attached searchable PDF details the specific reasonable steps it has taken to avoid originating illegal robocall traffic as part of its robocall mitigation program, and, if applicable, the type of extension or extensions it received under 47 CFR § 64.6304.';
      this.stirShakenType = 'Partial';
    }
    else if (type == 'No') {
      this.stirShakenText = 'No STIR/SHAKEN Implementation – Performing Robocall Mitigation. The filer certifies that it commits to respond to all traceback requests from the Commission, law enforcement, and the industry traceback consortium, and to cooperate with such entities in investigating and stopping any illegal robocallers that use its service to originate calls, and that none of the voice traffic that originates on its network is authenticated with STIR/SHAKEN, and that all of the voice traffic that originates on its network is subject to a robocall mitigation program. The filer also certifies that the attached searchable PDF details the specific reasonable steps it has taken to avoid originating illegal robocall traffic as part of its robocall mitigation program, and, if applicable, the type of extension or extensions it received under 47 CFR § 64.6304.';
      this.stirShakenType = 'No';
    }
  }

  GetRMDNotification(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    const userId = +sessionStorage.getItem('UserId');
    this.rmdupdatesService.GetRMDUpdatesUnreadCount(this.tokenKey, userId).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.rmdUnread = data["unreadCount"];

          sessionStorage.setItem('rmdUnread', this.rmdUnread.toString());

          if (this.rmdUnread > 0) {
            sessionStorage.setItem('rmdUnreadflag', 'false');
            this.rmdUnreadflag = false;
          }
        }
      },
      error => {
      },
    );
  }

}
